// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 66) return "static/chunks/66-24d36c87b1d24e81.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "bc98253f" : chunkId) + "." + {"501":"4b91974175989856","2121":"0513aaf310897dba","2748":"c7b066ccfd324f69","2831":"b4def2d1b518affe","5113":"a2209ce2024c72aa","8974":"3a841ed4e0fda24d","9592":"1bfcdf665f0d6bc2"}[chunkId] + ".js";
};